import { getOktaDomain } from 'helpers/okta/consts';

export const WIDGET_CONTAINER_ID = 'widget-container';
export const OKTA_INVALID_CREDENTIALS_ERROR_CODE = 'E0000004';

export const getOktaErrorCode = (error) =>
	error?.errorCode || error?.xhr?.responseJSON?.errorCode || error?.responseJSON?.errorCode;

export const getWidgetEmailValue = () => {
	if (typeof document === 'undefined') return '';
	const container = document?.getElementById(WIDGET_CONTAINER_ID);
	if (!container) return '';
	const input = container.querySelector('input[name="username"], input#okta-signin-username, input[type="email"]');
	return input?.value?.trim() || '';
};

export const getOktaWidgetConfig = (authClient) => {
	const { clientId, issuer, redirectUri, scopes } = authClient?.options || {};
	return {
		baseUrl: getOktaDomain(),
		clientId,
		redirectUri,
		authParams: {
			issuer,
			scopes,
		},
		authClient,
		el: `#${WIDGET_CONTAINER_ID}`,
		i18n: {
			en: {
				[`errors.${OKTA_INVALID_CREDENTIALS_ERROR_CODE}`]: 'Username or password incorrect',
			},
		},
		useClassicEngine: true,
		brandName: 'Openlane',
		colors: {
			brand: '#0061ff',
		},
		features: {
			rememberMe: false,
		},
		helpLinks: {
			help: 'https://www.openlane.com/contact-us/',
			forgotPassword: '/password/forgot',
		},
	};
};
